import AssignedPatientsModal from './AssignedPatientsModal';

export default AssignedPatientsModal;
